import { render } from "./SectionTimeline.vue?vue&type=template&id=67448d74&scoped=true"
import script from "./SectionTimeline.vue?vue&type=script&lang=js"
export * from "./SectionTimeline.vue?vue&type=script&lang=js"

import "./SectionTimeline.vue?vue&type=style&index=0&id=67448d74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67448d74"]])

export default __exports__